import Excel from "exceljs";

export default function extractPromotionTarget(e, id) {
  return new Promise((resolve, reject) => {
    const wb = new Excel.Workbook();
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.readAsArrayBuffer(file);
    const tempRow = [];

    reader.onload = () => {
      const buffer = reader.result;
      wb.xlsx.load(buffer).then((workBook) => {
        workBook.eachSheet((sheet) => {
          sheet.eachRow((row, rowIndex) => {
            if (rowIndex > 1) {
              tempRow.push({
                target_shop_name: row.values[1],
                work_shortcode: row.values[2],
                target_amount: row.values[3],
              });
            }
          });
        });
        if (tempRow.length > 0) resolve(tempRow);
      });
    };
  });
}
